<template>
  <View direction="row-reverse" align="center" v-if="renters?.length">
    <Text variant="label-small" v-if="renters.length > 3">+{{ notShownRentersAmount }}</Text>
    <div class="avatar" v-for="renter in firstThreeRenters" :key="renter.id">
      <RenterProfileLink :property-id="propertyId" :renter-id="renter.id" :decoration="false">
        <Avatar class="avatar" size="small" :user-name="renter.user.name" :show-single-letter="true" />
      </RenterProfileLink>
    </div>
  </View>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Text, Avatar, View } from '@tallo/design-system';
import { RenterDto } from '@tallo/renter';

import RenterProfileLink from './renter-profile-link.vue';

const props = defineProps<{
  renters: RenterDto[];
  propertyId: string;
}>();
const firstThreeRenters = computed(() => props.renters.slice(0, 3));
const notShownRentersAmount = computed(() => props.renters.length - 3);
</script>

<style lang="scss" scoped>
.avatar {
  margin-left: -0.3rem;
  cursor: pointer;
  border: 0.063rem solid var(--t-color-neutral-white);

  &:last-child {
    margin-left: 0;
  }
}
</style>
